import { Component, DoCheck } from "@angular/core";
import { SwUpdate } from "@angular/service-worker";
import { environment } from "src/environments/environment";
declare var $: any;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements DoCheck {
  public session: boolean = false;

  public title = (environment.appName || '').toUpperCase();

  constructor(private swUpdate: SwUpdate) {
    this.getSession();

    if (this.swUpdate.isEnabled){
      this.swUpdate.available.subscribe(() => {
        if (confirm('Hay una nueva versión disponible. ¿Desea actualizar?')) {
          window.location.reload();
        }
      })
    }

    this.swUpdate.checkForUpdate()

  }

  ngDoCheck(): void {
    this.getSession();
    document.title = this.title;
  }

  getSession() {
    if (localStorage.getItem("session")) {
      this.session = true;
    } else {
      this.session = false;
    }
  }

  onLogin(event) {
    this.getSession();
  }
}
